import React from 'react';
import { Heart } from 'lucide-react';
import { useFavorites } from '@/lib/favoritesStore';

export default function FavoriteButton({ productId, className = '' }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const fav = isFavorite(productId);

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(productId);
      }}
      className={`flex items-center justify-center w-10 h-10 bg-background/80 backdrop-blur-sm hover:bg-background transition-colors ${className}`}
      aria-label={fav ? 'Fjarlægja úr uppáhald' : 'Bæta í uppáhald'}
    >
      <Heart
        className={`w-5 h-5 transition-all ${fav ? 'fill-accent text-accent' : 'text-primary'}`}
      />
    </button>
  );
}